import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import BIZTaxConolInfoNode from "@/business/businessFile/QS420/bizTaxInfo/bizTaxContolInfoNode.js";
import GROUP_INFO from "../QS420_groupInfo.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var backfillOldData = function backfillOldData(_this) {
  var TaxCustInfo = _.get(_this, "oppBusiData.oldBusiData.TaxCustInfo");
  if (!_.isEmpty(TaxCustInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], TaxCustInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var TaxCustInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  TaxCustInfo && (TaxCustInfo["UNGET_TAXPAYERID_REASON1"] || TaxCustInfo["UNGET_TAXPAYERID_REASON1"] == "") && (TaxCustInfo["NO_TAXPAYERID_REASON"] = TaxCustInfo["UNGET_TAXPAYERID_REASON1"]) && (TaxCustInfo["NO_TAXPAYERID_REASON_DATA_SOURCE"] = TaxCustInfo["UNGET_TAXPAYERID_REASON1_DATA_SOURCE"]) && (TaxCustInfo["NO_TAXPAYERID_REASON_UPDATE_FLAG"] = TaxCustInfo["UNGET_TAXPAYERID_REASON1_UPDATE_FLAG"]);
  TaxCustInfo && (TaxCustInfo["UNGET_TAXPAYERID_REASON2"] || TaxCustInfo["UNGET_TAXPAYERID_REASON2"] == "") && (TaxCustInfo["NO_TAXPAYERID_REASON2"] = TaxCustInfo["UNGET_TAXPAYERID_REASON2"]) && (TaxCustInfo["NO_TAXPAYERID_REASON2_DATA_SOURCE"] = TaxCustInfo["UNGET_TAXPAYERID_REASON2_DATA_SOURCE"]) && (TaxCustInfo["NO_TAXPAYERID_REASON2_UPDATE_FLAG"] = TaxCustInfo["UNGET_TAXPAYERID_REASON2_UPDATE_FLAG"]);
  TaxCustInfo && (TaxCustInfo["UNGET_TAXPAYERID_REASON3"] || TaxCustInfo["UNGET_TAXPAYERID_REASON3"] == "") && (TaxCustInfo["NO_TAXPAYERID_REASON3"] = TaxCustInfo["UNGET_TAXPAYERID_REASON3"]) && (TaxCustInfo["NO_TAXPAYERID_REASON3_DATA_SOURCE"] = TaxCustInfo["UNGET_TAXPAYERID_REASON3_DATA_SOURCE"]) && (TaxCustInfo["NO_TAXPAYERID_REASON3_UPDATE_FLAG"] = TaxCustInfo["UNGET_TAXPAYERID_REASON3_UPDATE_FLAG"]);;

  TaxCustInfo && (TaxCustInfo["CITIZENSHIP"] || TaxCustInfo["CITIZENSHIP"] == "") && (TaxCustInfo["CITIZENSHIP_ST"] = TaxCustInfo["CITIZENSHIP"]) && (TaxCustInfo["CITIZENSHIP_ST_DATA_SOURCE"] = TaxCustInfo["CITIZENSHIP_DATA_SOURCE"]) && (TaxCustInfo["CITIZENSHIP_ST_UPDATE_FLAG"] = TaxCustInfo["CITIZENSHIP_UPDATE_FLAG"]);
  TaxCustInfo && (TaxCustInfo["CITIZENSHIP2"] || TaxCustInfo["CITIZENSHIP2"] == "") && (TaxCustInfo["CITIZENSHIP_ST2"] = TaxCustInfo["CITIZENSHIP2"]) && (TaxCustInfo["CITIZENSHIP_ST2_DATA_SOURCE"] = TaxCustInfo["CITIZENSHIP2_DATA_SOURCE"]) && (TaxCustInfo["CITIZENSHIP_ST2_UPDATE_FLAG"] = TaxCustInfo["CITIZENSHIP2_UPDATE_FLAG"]);
  TaxCustInfo && (TaxCustInfo["CITIZENSHIP3"] || TaxCustInfo["CITIZENSHIP3"] == "") && (TaxCustInfo["CITIZENSHIP_ST3"] = TaxCustInfo["CITIZENSHIP3"]) && (TaxCustInfo["CITIZENSHIP_ST3_DATA_SOURCE"] = TaxCustInfo["CITIZENSHIP3_DATA_SOURCE"]) && (TaxCustInfo["CITIZENSHIP_ST3_UPDATE_FLAG"] = TaxCustInfo["CITIZENSHIP3_UPDATE_FLAG"]);
  if (!_.isEmpty(TaxCustInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], TaxCustInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], TaxCustInfo);
  }
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      if (fieldAction == "DEFAULT_VALUE") {
        vm.$store.state.canCleanData && (item[fieldAction] = val);
      } else {
        item[fieldAction] = val;
      }
    };
  });
};

var SEL_NO_TAXPAYERID_REASON = [{
  DICT_ITEM: "1",
  DICT_ITEM_NAME: "居民国(地区)不发放纳税人识别号"
}, {
  DICT_ITEM: "2",
  DICT_ITEM_NAME: "账户持有人未能取得纳税人识别号"
}];
var ADDRESS_TYPE = [{
  DICT_ITEM: "0",
  DICT_ITEM_NAME: "办公地址"
}, {
  DICT_ITEM: "1",
  DICT_ITEM_NAME: "注册地址"
}];

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  _.set(fields, "IS_TAXPAYER_IDNO_1.FIELD_TYPE", "radio");
  _.set(fields, "IS_TAXPAYER_IDNO_2.FIELD_TYPE", "radio");
  _.set(fields, "IS_TAXPAYER_IDNO_3.FIELD_TYPE", "radio");
  _.set(fields, "SEL_NO_TAXPAYERID_REASON1.FIELD_DICT_NAME", SEL_NO_TAXPAYERID_REASON);
  _.set(fields, "SEL_NO_TAXPAYERID_REASON2.FIELD_DICT_NAME", SEL_NO_TAXPAYERID_REASON);
  _.set(fields, "SEL_NO_TAXPAYERID_REASON3.FIELD_DICT_NAME", SEL_NO_TAXPAYERID_REASON);
  _.set(fields, "ADDRESS_TYPE.FIELD_DICT_NAME", ADDRESS_TYPE);
  _.set(fields, "CITIZENSHIP_ST.FIELD_TYPE", "selector");
  _.set(fields, "CITIZENSHIP_ST2.FIELD_TYPE", "selector");
  _.set(fields, "CITIZENSHIP_ST3.FIELD_TYPE", "selector");
  _.set(fields, "REG_COUNTRY.FIELD_TYPE", "selector");
  _.set(fields, "NATION_ENG.FIELD_TYPE", "selector");

  _.set(fields, "TAXPAYER_IDNO.isLongItem", true);
  _.set(fields, "TAXPAYER_IDNO2.isLongItem", true);
  _.set(fields, "TAXPAYER_IDNO3.isLongItem", true);

  _.set(fields, "SEL_NO_TAXPAYERID_REASON1.isLongItem", true);
  _.set(fields, "SEL_NO_TAXPAYERID_REASON2.isLongItem", true);
  _.set(fields, "SEL_NO_TAXPAYERID_REASON3.isLongItem", true);

  _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
  _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.IS_FINANCIAL_INSTITUTION.FIELD_TYPE = "radio";
  _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.PASSIVE_NFE.FIELD_TYPE = "radio";
  _this.groupDatas.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.REG_COUNTRY.FIELD_TITLE = "地区国家";

  _this.groupDatasTpl.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.TAX_RESIDENT_TYPE.FIELD_TYPE = "radio";
  _this.groupDatasTpl.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.IS_FINANCIAL_INSTITUTION.FIELD_TYPE = "radio";
  _this.groupDatasTpl.TAX_INFO.MA_CUST_TAX_INFO_MODULE[0].FIELDS.PASSIVE_NFE.FIELD_TYPE = "radio";
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var custTaxInfo, oldTaxInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              custTaxInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH]);
              oldTaxInfo = _.get(params, "" + SAVE_PATH) || {};

              custTaxInfo.BIRTHDAY = "";
              custTaxInfo.BIRTH_ADDRESS = "";
              custTaxInfo.BIRTH_ADDRESS_ENG = "";
              custTaxInfo.BIRTH_CITY_ENG = "";
              custTaxInfo.BIRTH_NATION_ENG = "";
              custTaxInfo.BIRTH_PROVINCE_ENG = "";
              custTaxInfo.CITIZENSHIP_CN = "";
              custTaxInfo.CTRL_SHARE_RATIO = "";
              custTaxInfo.CTRL_TYPE = "";
              custTaxInfo.CUST_NAME = "";
              custTaxInfo.TAXPAYER_IDNO1 = custTaxInfo.TAXPAYER_IDNO;
              custTaxInfo["UNGET_TAXPAYERID_REASON1"] = custTaxInfo["NO_TAXPAYERID_REASON"] || "";
              custTaxInfo["UNGET_TAXPAYERID_REASON2"] = custTaxInfo["NO_TAXPAYERID_REASON2"] || "";
              custTaxInfo["UNGET_TAXPAYERID_REASON3"] = custTaxInfo["NO_TAXPAYERID_REASON3"] || "";

              delete custTaxInfo["NO_TAXPAYERID_REASON"];
              delete custTaxInfo["NO_TAXPAYERID_REASON2"];
              delete custTaxInfo["NO_TAXPAYERID_REASON3"];
              custTaxInfo["CITIZENSHIP"] = custTaxInfo["CITIZENSHIP_ST"];
              custTaxInfo["CITIZENSHIP2"] = custTaxInfo["CITIZENSHIP_ST2"];
              custTaxInfo["CITIZENSHIP3"] = custTaxInfo["CITIZENSHIP_ST3"];

              delete custTaxInfo["CITIZENSHIP_ST"];
              delete custTaxInfo["CITIZENSHIP_ST2"];
              delete custTaxInfo["CITIZENSHIP_ST3"];
              custTaxInfo.BIRTH_COUNTRY = "";
              custTaxInfo.CTRL_FLAG = "0";
              custTaxInfo.CTRL_NON_RESIDENT = custTaxInfo.TAX_RESIDENT_TYPE === "1" ? "0" : "1";
              custTaxInfo.FULL_BIRTHD_ADDRESS_ENG = "";
              custTaxInfo.NO_TAXPAYERID_REASON = custTaxInfo["SEL_NO_TAXPAYERID_REASON1"] ? (SEL_NO_TAXPAYERID_REASON[custTaxInfo["SEL_NO_TAXPAYERID_REASON1"] - 1]["DICT_ITEM_NAME"] || "") + (custTaxInfo["UNGET_TAXPAYERID_REASON1"] ? ":" + custTaxInfo["UNGET_TAXPAYERID_REASON1"] : custTaxInfo["UNGET_TAXPAYERID_REASON1"]) : "";
              custTaxInfo.NO_TAXPAYERID_REASON2 = custTaxInfo["SEL_NO_TAXPAYERID_REASON2"] ? (SEL_NO_TAXPAYERID_REASON[custTaxInfo["SEL_NO_TAXPAYERID_REASON2"] - 1]["DICT_ITEM_NAME"] || "") + (custTaxInfo["UNGET_TAXPAYERID_REASON2"] ? ":" + custTaxInfo["UNGET_TAXPAYERID_REASON2"] : custTaxInfo["UNGET_TAXPAYERID_REASON2"]) : "";
              custTaxInfo.NO_TAXPAYERID_REASON3 = custTaxInfo["SEL_NO_TAXPAYERID_REASON3"] ? (SEL_NO_TAXPAYERID_REASON[custTaxInfo["SEL_NO_TAXPAYERID_REASON3"] - 1]["DICT_ITEM_NAME"] || "") + (custTaxInfo["UNGET_TAXPAYERID_REASON3"] ? ":" + custTaxInfo["UNGET_TAXPAYERID_REASON3"] : custTaxInfo["UNGET_TAXPAYERID_REASON3"]) : "";
              custTaxInfo.SEL_NO_TAXPAYERID_REASON1_TEXT = custTaxInfo.NO_TAXPAYERID_REASON;
              custTaxInfo.SEL_NO_TAXPAYERID_REASON2_TEXT = custTaxInfo.NO_TAXPAYERID_REASON2;
              custTaxInfo.SEL_NO_TAXPAYERID_REASON3_TEXT = custTaxInfo.NO_TAXPAYERID_REASON3;


              if (custTaxInfo.TAX_RESIDENT_TYPE == "1") {
                custTaxInfo.CITIZENSHIP_CN = "CN";
                custTaxInfo.CITIZENSHIP = "CN";
                custTaxInfo.NATION_ENG = "CN";
              }

              custTaxInfo.FULL_ADDRESS_ENG = "";
              if (!!custTaxInfo.NATION_ENG && custTaxInfo.TAX_RESIDENT_TYPE !== "1") {
                custTaxInfo.FULL_ADDRESS_ENG = custTaxInfo.NATION_ENG + "(国家)";
              }
              if (!!custTaxInfo.PROVINCE_ENG) {
                custTaxInfo.FULL_ADDRESS_ENG = custTaxInfo.FULL_ADDRESS_ENG + custTaxInfo.PROVINCE_ENG + "(省)";
              }
              if (!!custTaxInfo.CITY_ENG) {
                custTaxInfo.FULL_ADDRESS_ENG = custTaxInfo.FULL_ADDRESS_ENG + custTaxInfo.CITY_ENG + "(市)";
              }

              if (!!custTaxInfo.ADDRESS_ENG) {
                custTaxInfo.FULL_ADDRESS_ENG = custTaxInfo.FULL_ADDRESS_ENG + custTaxInfo.ADDRESS_ENG;
              }

              custTaxInfo.FULL_BIRTHD_ADDRESS_ENG = "";
              if (!!custTaxInfo.BIRTH_NATION_ENG) {
                custTaxInfo.FULL_BIRTHD_ADDRESS_ENG = custTaxInfo.BIRTH_NATION_ENG + "(国家)";
              }

              if (!!custTaxInfo.BIRTH_PROVINCE_ENG) {
                custTaxInfo.FULL_BIRTHD_ADDRESS_ENG = custTaxInfo.FULL_BIRTHD_ADDRESS_ENG + custTaxInfo.BIRTH_PROVINCE_ENG + "(省)";
              }

              if (!!custTaxInfo.BIRTH_CITY_ENG) {
                custTaxInfo.FULL_BIRTHD_ADDRESS_ENG = custTaxInfo.FULL_BIRTHD_ADDRESS_ENG + custTaxInfo.BIRTH_CITY_ENG + "(市)";
              }

              if (!!custTaxInfo.BIRTH_ADDRESS_ENG) {
                custTaxInfo.FULL_BIRTHD_ADDRESS_ENG = custTaxInfo.FULL_BIRTHD_ADDRESS_ENG + custTaxInfo.BIRTH_ADDRESS_ENG;
              }


              if (custTaxInfo.IS_FINANCIAL_INSTITUTION == "1") {
                custTaxInfo.PASSIVE_NFE = "";
              }

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], custTaxInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, oldTaxInfo, custTaxInfo));

            case 49:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    _this.busiLogic["CHECK_TAX_FLAG"](_this, _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.TAX_RESIDENT_TYPE, _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS, _this.groupDatas[GROUP_ID][MODULE_ID][0]);
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  "CHECK_HAS_TAXPAYER_IDNO": function CHECK_HAS_TAXPAYER_IDNO(_this, field, fieldData, md) {
    if (field.DEFAULT_VALUE != "") {
      if (field.DEFAULT_VALUE == "1") {
        fieldData.OPP_NO_TAXPAYERID_REASON.FIELD_CONTROL = "1";
        fieldData.TAXPAYER_IDNO.FIELD_CONTROL = "0";
      } else {
        fieldData.TAXPAYER_IDNO.FIELD_CONTROL = "1";
        fieldData.OPP_NO_TAXPAYERID_REASON.FIELD_CONTROL = "0";
      }
    }
  },
  "CHECK_HAS_TAXPAYER_IDNO2": function CHECK_HAS_TAXPAYER_IDNO2(_this, field, fieldData, md) {
    if (field.DEFAULT_VALUE != "") {
      if (field.DEFAULT_VALUE == "1") {
        fieldData.OPP_NO_TAXPAYERID_REASON2.FIELD_CONTROL = "1";
        fieldData.TAXPAYER_IDNO2.FIELD_CONTROL = "0";
      } else {
        fieldData.TAXPAYER_IDNO2.FIELD_CONTROL = "1";
        fieldData.OPP_NO_TAXPAYERID_REASON2.FIELD_CONTROL = "0";
      }
    }
  },
  "CHECK_HAS_TAXPAYER_IDNO3": function CHECK_HAS_TAXPAYER_IDNO3(_this, field, fieldData, md) {
    if (field.DEFAULT_VALUE != "") {
      if (field.DEFAULT_VALUE == "1") {
        fieldData.OPP_NO_TAXPAYERID_REASON3.FIELD_CONTROL = "1";
        fieldData.TAXPAYER_IDNO3.FIELD_CONTROL = "0";
      } else {
        fieldData.TAXPAYER_IDNO3.FIELD_CONTROL = "1";
        fieldData.OPP_NO_TAXPAYERID_REASON3.FIELD_CONTROL = "0";
      }
    }
  },
  "CHECK_IS_FINANCIAL_INSTITUTION": function CHECK_IS_FINANCIAL_INSTITUTION(_this, field, fieldData, md) {
    if (field.DEFAULT_VALUE != "") {
      if (field.DEFAULT_VALUE == "1") {
        fieldData.PASSIVE_NFE.FIELD_CONTROL = "1";
        _this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE[0].MODULE_CONTROL = "0";
        fieldData.PASSIVE_NFE.DEFAULT_VALUE = "";
      } else {
        fieldData.PASSIVE_NFE.FIELD_CONTROL = "0";
      }
    }
  },

  "CHECK_PASSIVE_NFE": function CHECK_PASSIVE_NFE(_this, field, fieldData, md) {
    if (field.FIELD_LAST_CHOOSE_VALUE != undefined) {
      field.DEFAULT_VALUE = field.FIELD_LAST_CHOOSE_VALUE;
    }

    if (field.DEFAULT_VALUE == "" || field.DEFAULT_VALUE == "3") {
      _this.$blMethod.setModulesControl(_this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE, 0);
    } else {
      _this.$blMethod.setModulesControl(_this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE, 1);
      _.each(_this.groupDatas.TAX_INFO.MA_CONTROLER_TAX_INFO_MODULE, function (module) {
        _this.busiLogic["CHECK_TAX_FLAG"](_this, module.FIELDS.TAX_RESIDENT_TYPE, module.FIELDS, module);
      });
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizTaxInfo/bizTaxCustInfoNode.js
// module id = 162
// module chunks = 2